import ProductCarousel from './lib/product-carousel';
import RecipeCarousel from './lib/recipe-carousel';

import './scss/home.scss';

ProductCarousel.createFromSelector('.js-products-carousel');
RecipeCarousel.createFromSelector('.js-recipes-carousel');
